module.exports = __webpack_public_path__ + "static/media/form-validator.b9fc9249.png";